import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TaskStatus } from '../../shared/constants';

/*
 * Generate project Status Translated text content
 * Usage:
 *   value | projectStatus
 * Example:
 *   {{ project.Status | projectStatus }}
 */
@Pipe({ name: 'projectStatus' })
export class ProjectStatusPipe implements PipeTransform {
  constructor(public translateService: TranslateService) {}
  transform(projectStatus: string): string {
    let textResult = '';
    switch (projectStatus) {
      case TaskStatus.OPEN:
        textResult = this.translateService.instant('COMMON.STATUS.OPEN');
        break;
      case TaskStatus.IN_PROGRESS:
        textResult = this.translateService.instant('COMMON.STATUS.IN_PROGRESS');
        break;
      case TaskStatus.WAITING_ON_CUSTOMER:
        textResult = this.translateService.instant('COMMON.STATUS.WAITING_ON_CUSTOMER');
        break;
      case TaskStatus.COMPLETED:
        textResult = this.translateService.instant('COMMON.STATUS.COMPLETED');
        break;
      default:
        textResult = projectStatus;
        break;
    }
    return textResult;
  }
}
